import { FieldType } from '@wix/wix-data-schema-types'
import { RICH_CONTENT_ROLE } from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const { richContent } = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Rich_Content',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  panel: {
    height: 297,
    title: 'Connect_Panel_Title_Rich_Content',
    helpId: 'e03fed6e-cccd-432c-8ddd-d1a53264648a',
  },
  sections: [
    {
      role: RICH_CONTENT_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Rich_Content_Label',
          prop: 'value',
          supportedFieldTypes: [richContent],
          defaultFieldType: richContent,
          supportsReferenceFields: true,
        },
      ],
      manageContentPanel: {
        alternativeTitle: 'Manage_Content_Panel_V2_Title_RichContent',
      },
    },
  ],
  compactErrorPanel: true,
})
